"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.colours = exports["default"] = void 0;
var colours = {
  //neutrals
  raisin: '#212322',
  charcoal: '#3F4444',
  ash: '#B2B4B4',
  wolf: '#DDDDDD',
  smoke: '#F0F0F0',
  cloud: '#F5F5F5',
  snow: '#F9F9F9',
  white: '#FFFFFF',
  //presentational
  watermelon: '#FD7280',
  prince: '#4129AC',
  lemon: '#FEDF1A',
  shamrock: '#2DD79A',
  azure: '#368EF8',
  //presentational-accent
  blush: '#FFF1F2',
  haze: '#D8DDEF',
  buttermilk: '#FFFCE7',
  honeydew: '#E6F8F2',
  baby: '#EAF3FF'
};
exports.colours = exports["default"] = colours;
//# sourceMappingURL=colours.js.map